import { Typography } from "@hellocarbo/lasagne";

import Card from "../ui/Card";

function ScenariosAndTrajectory() {
  return (
    <Card className="col-span-1">
      <Typography as="h2" step="2" weight="bold">
        Scénarios et trajectoire
      </Typography>
    </Card>
  );
}

export default ScenariosAndTrajectory;
